import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { LectionarySource, LectionarySourceService } from '../../services/lectionary-source.service';
import { LectionaryItemType, LectionaryItemTypeService } from '../../services/lectionary-item-type.service';
import { LectionaryItemNameService } from '../../services/lectionary-item-name.service';

@Component({
  selector: 'app-lectionary-item-search',
  templateUrl: './lectionary-item-search.component.html',
  styleUrls: ['./lectionary-item-search.component.css']
})
export class LectionaryItemSearchComponent implements OnInit {

  @Output() searchItems = new EventEmitter<LectionaryItemSearchModel>();
  public lectionarySources: LectionarySource[]; 
  public lectionaryItemTypes: LectionaryItemType[]; 
  public listsLoaded: boolean;

  public model: LectionaryItemSearchModel;

  constructor(
    private lectionaryItemTypeSvc: LectionaryItemTypeService,
    private lectionarySourceSvc: LectionarySourceService
  ) { }


  ngOnInit() {
    this.listsLoaded = false;
    this.model = new LectionaryItemSearchModel();    
    this.getSearchValues();
  }

  public getSearchValues() {
  
    var lectionarySourcePromise = this.lectionarySourceSvc.loadEntites().then(
      (data) => {
        this.lectionarySources = data.filter(s=> {return s.IsActive == true});
      }
    )

    var lectionaryItemTypePromise = this.lectionaryItemTypeSvc.loadEntities().then(
      (data) => {
        this.lectionaryItemTypes = data;
      }
    ) 

    Promise.all([lectionarySourcePromise, lectionaryItemTypePromise]).then(
      (data) => { 
        console.log("All promises are completed");
        this.listsLoaded = true;
        this.getSavedModel();
      }
    )

  }

  public getSavedModel() {
    var savedModel = localStorage["lectionaryItemSearch"];
    console.log("getSavedModel", savedModel);
    if (savedModel != undefined) {
      this.model = JSON.parse(savedModel);
      console.log("parsedModel", this.model);
      this.search();
    }
  }

  public search() {
    console.log("Search", this.model);
    localStorage["lectionaryItemSearch"] = JSON.stringify(this.model);
    this.searchItems.emit(this.model); 
  }

  public onSourceChange(e: any) {
    console.log(e);
  }

  public compareLectionarySource(obj1: LectionarySource, obj2: LectionarySource) {
 
    if (obj1 == undefined) return false;
    if (obj1 === obj2) { return true };
     return false;
   }
 

}

export class LectionaryItemSearchModel {
  public LectionarySource: number;
  //public LectionaryItemType: number;
  public LectionaryItemName: string;
  public LectionaryItemNameId: number;
  public Html: string;
}
